import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import { getUrl } from '~/services/shop/utils';

export default function getConfirmed(transactionId: string, basketReference: string) {
    const url = getUrl('/checkout/confirmed');
    url.searchParams.set('transactionId', transactionId);
    url.searchParams.set('basketReference', basketReference || '');

    return shop
        .get(url, {
            timeout: 60 * 1000, // 60 seconds
            retry: 3,
        })
        .json<ShopTypes.ConfirmPaymentResult>();
}
